import { FormComponent } from '@/components/FormComponent';
import MediaCarousel from '@/components/media-carousel/MediaCarousel';
import { cn } from '@/lib/utils';
import { components } from '@/types/strapi';
import PopupDynamicZoneManager from './manager';

export interface TwoColumnPopupProps {
	content: components['schemas']['SharedPopupContentComponent'];
	locale?: string;
}

export const TwoColumnPopup = ({
	content,
	locale = 'en',
}: TwoColumnPopupProps) => {
	const { imagePosition, backgroundColor } = content;
	const isLeft = imagePosition === 'left';
	const isRight = imagePosition === 'right';

	return (
		<div
			className={cn(
				'flex flex-col items-stretch overflow-hidden',
				'rounded-xl shadow-lg transition-transform duration-300',
				'lg:min-h-[500px] lg:flex-row',
				'animate-in fade-in slide-in-from-bottom-4 duration-700',
			)}
			style={{ backgroundColor: backgroundColor || 'white' }}>
			{isLeft && content.images && content.images.length > 0 && (
				<div className="relative h-full flex-1 lg:w-1/2">
					<div className="h-full">
						<MediaCarousel images={content.images} />
					</div>
				</div>
			)}

			<div className="flex flex-1 flex-col justify-center p-6 lg:w-1/2 lg:p-10 xl:p-12">
				{content.heading && (
					<h2 className="relative mb-2 text-2xl font-bold tracking-tight text-gray-800 lg:text-3xl xl:text-4xl">
						{content.heading}
					</h2>
				)}
				{content.description && (
					<div
						className="prose mb-8 max-w-none text-gray-600"
						dangerouslySetInnerHTML={{
							__html: content.description,
						}}
					/>
				)}
				{content.form && (
					<div className="space-y-6">
						<FormComponent
							inputs={content.form?.inputs}
							submit_button={content.submit_button}
							pdf_name={content.pdf?.name}
							pdf_url={content.pdf?.url}
						/>
					</div>
				)}
				{content.dynamic_zone &&
					Array.isArray(content.dynamic_zone) &&
					content.dynamic_zone.length > 0 && (
						<div className="mt-8">
							<PopupDynamicZoneManager
								dynamicZone={content.dynamic_zone}
								locale={locale}
							/>
						</div>
					)}
			</div>

			{isRight && content.images && content.images.length > 0 && (
				<div className="relative h-full flex-1 lg:w-1/2">
					<div className="h-full">
						<MediaCarousel images={content.images} />
					</div>
				</div>
			)}
		</div>
	);
};
